var React = require('react');
var { sanitize } = require('isomorphic-dompurify');
var PurchaseInformation = require('./ReactDependencies/PurchaseInformation.jsx');
var PaymentInformation = require('./ReactDependencies/PaymentInformation.jsx');
var BillingInformation = require('./ReactDependencies/BillingInformation.jsx');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');
var AutoRenewInformation = require('./ReactDependencies/AutoRenewInformation.jsx');
var labels = require('MemberJoinLabels');
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');

class Step6 extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    componentDidMount() {
        this.handleMembershipProgram();
    }

    bindFunctions() {
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);
        this.handleMembershipProgram = this.handleMembershipProgram.bind(this);
    }

    prevStepValid() {
        return this.props.appState.currentStep > 3 || this.props.appState.debugMode;
    }

    nextStepValid() {
        return this.props.appState.currentStep <= 6 || this.props.appState.debugMode;
    }

    handleMembershipProgram() {
        if (this.props.appState.currentStep == 6) {
            if (this.props.appState.productType == 'ECY1' || this.props.appState.productType == 'ECY2' || this.props.appState.productType == 'ECY3' ) {              
                if (this.props.appState.yearsInPractice == undefined && this.props.appState.yearsInPractice == null && typeof this.props.appState.yearsInPractice !== 'number') {
                    this.props.appState.yearsInPractice = this.props.appState.productType.charAt(this.props.appState.productType.length - 1);
                }
                var yip = this.props.appState.yearsInPractice;
                console.log("YIP " + yip);

                if (yip != 1 && yip != 2 && yip != 3) {
                    this.props.disableUI();
                    this.props.showMembershipModal();

                    this.props.goPrevStep();
                }
                else {
                    console.log("You qualify for the Early Career Membership");
                }
            }
        }
    }

    render() {
        const bottomContent = sanitize(labels.bottomContent);


        return <div className={"step-6-container"}>
            <$form onSubmit={(event) => this.props.submitApplication(event)} ref={c => { this.form = c }}>

                <div className={'row'}>
                    <div className={'col-md-8'}>
                        <PurchaseInformation {...this.props} />                        
                        {/*<PaymentInformation {...this.props} />*/}
                        {/*<AutoRenewInformation {...this.props} />*/}
                        {/*<BillingInformation {...this.props} />*/}
                    </div>
                    <div className={'col-md-4'}>
                        {this.props.cartComponent}
                    </div>
                </div>

                <p dangerouslySetInnerHTML={{ __html: bottomContent }}></p>

                <ChangeStepButtons
                    disableUI={this.props.appState.disableUI}
                    nextStepValid={this.nextStepValid}
                    prevStepValid={this.prevStepValid}
                    goPrevStep={this.props.goPrevStep}
                    nextLabel={labels.submitApplication}
                    currentStep={this.props.appState.currentStep} />
            </$form>
        </div>;
    }
}

module.exports = Step6;